// The sign-in sheet, a page over the one underneath. "Continue with Google" calls signIn() (src/ui/account.ts): on
// Cloudflare that goes to Google and comes back to this page; on the dev server it signs in the mock account at once
// and calls `onDone`. `onClose` is "not now".
import { Body, Footer, Layer, Page, TopBar } from "../common";
import { signIn } from "../account";
import "./landing.css";

export function SignIn({ onDone, onClose }: { onDone: () => void; onClose: () => void }) {
  return (
    <Layer>
      <Page className="sm lp-signin">
        <TopBar onBack={onClose} />
        <Body className="lp-center">
          <h1 className="sm-ask">Save your cartoon</h1>
          <p className="lp-lede">Free to start. Your first videos are on us.</p>
        </Body>
        <Footer>
          <div className="lp-stack">
            <button className="lp-google" onClick={() => { if (signIn()) onDone(); }}>
              <svg width="22" height="22" viewBox="0 0 48 48" aria-hidden>
                <path fill="#EA4335" d="M24 9.5c3.5 0 6.6 1.2 9.1 3.6l6.8-6.8C35.8 2.4 30.3 0 24 0 14.6 0 6.5 5.4 2.6 13.2l7.9 6.1C12.4 13.6 17.7 9.5 24 9.5z" />
                <path fill="#4285F4" d="M46.5 24.5c0-1.6-.1-3.1-.4-4.5H24v9h12.7c-.6 3-2.2 5.4-4.7 7.1l7.6 5.9c4.4-4.1 6.9-10.1 6.9-17.5z" />
                <path fill="#FBBC05" d="M10.5 28.7c-.5-1.5-.8-3-.8-4.7s.3-3.2.8-4.7l-7.9-6.1C.9 16.4 0 20.100 0 24s.9 7.600 2.600 10.800l7.900-6.100z" />
                <path fill="#34A853" d="M24 48c6.500 0 11.900-2.100 15.900-5.800l-7.600-5.900c-2.100 1.400-4.900 2.300-8.300 2.300-6.300 0-11.600-4.100-13.500-9.800l-7.900 6.100C6.500 42.600 14.600 48 24 48z" />
              </svg>
              Continue with Google
            </button>
            <button className="link-btn" onClick={onClose}>Not now</button>
          </div>
        </Footer>
      </Page>
    </Layer>
  );
}
